module.exports = __webpack_public_path__ + "static/media/card-front-blue.e94456e4.png";